import React, { useState, useEffect } from 'react';
import {config} from "../../shared/config.js";
import * as util from '../../shared/commons.js';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../../shared/ShowError.jsx';
import Laoding from '../../shared/Laoding.jsx';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Dialog } from 'primereact/dialog';
import GeneralDialogFooter from '../../shared/GeneralDialogFooter.jsx';
import ShowConfirm from '../../shared/ShowConfirm.jsx';
import Table from 'react-bootstrap/Table';
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from 'primereact/checkbox';        
import { InputText } from 'primereact/inputtext';
import CityCombo from '../../combos/CityCombo.jsx';
import { FloatLabel } from 'primereact/floatlabel';
import FaDate from '../../shared/FaDate.jsx';
import { InputNumber } from 'primereact/inputnumber';
import UserTypeCombo from '../../combos/UserTypeCombo.jsx';
import { InputTextarea } from 'primereact/inputtextarea';
import ProductTypeCombo from '../../combos/ProductTypeCombo.jsx';

var editedModules = [];
var editedParameters = {};
export default function ProductList(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [productType, setProductType] = useState(null);
    const [products, setProducts] = useState([]);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [moduleFormVisible, setModuleFormVisible] = useState(false);
    const [priceFormVisible, setPriceFormVisible] = useState(false);
    const [proposeFormVisible, setProposeFormVisible] = useState(false);
    const [proposeEditFormVisible, setProposeEditFormVisible] = useState(false);
    const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
    const [confirmDeleteProposeVisible, setConfirmDeleteProposeVisible] = useState(false);
    const [confirmResetPasswordVisible, setConfirmResetPasswordVisible] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [productId, setProductId] = useState("");
    const [productIndex, setProductIndex] = useState(-1);
    const [proposeIndex, setProposeIndex] = useState(-1);
    const [enName, setEnName] = useState("");
    const [shortDescription, setShortDescription] = useState("");
    const [longDescription, setLongDescription] = useState("");
    const [modules, setModules] = useState([]);
    const [basePrice, setBasePrice] = useState(0);
    const [proposes, setProposes] = useState([]);
    const [proposeCode, setProposeCode] = useState("");
    const [proposeTitle, setProposeTitle] = useState("");
    const [proposeSum, setProposeSum] = useState(0);

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = function(){
        setLoading(true);
        var params = {
            param1:"0", 
            param2:"0", 
            param3:"0", 
            param4:"0", 
            param5:"0" 
        };
        var url = config.Server+`/basic/product/list`;
        console.log("params in show summary is>", params);
        console.log("url in show summary is>", url);
        
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("setProducts is> ", response);
                for(var i=0;i<response.length;i++){
                    
                }
                setProducts(response);
                setLoading(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                //setLoading(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            //setLoading(false);
        });

    }
    const onAddNewItemClick = function(){
        setProductType(null);
        setProductId("");
        setProductIndex(-1);
        setEnName("");
        setIsActive(true);
        setShortDescription("");
        setLongDescription("");
        setEditFormVisible(true);
    }
    const onRowEditClick = function(p, cInd){
        console.log("product is>", p)
        setProductId(p.id);
        setProductIndex(cInd);
        setProductType(p.productType);
        setEnName(p.enName);
        setIsActive(p.isActive);
        setShortDescription(p.shortDescription);
        setLongDescription(p.longDescription);
        setEditFormVisible(true);
    }
    const setRowActions = function (row, cInd) {
        return (
        <Row className="justify-content-md-center" style={{}}>
            <Button icon="pi pi-pencil" rounded severity="success" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowEditClick(row, cInd)} title="ویرایش" />
            <Button icon="pi pi-list" rounded severity="primary" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowModuleClick(row, cInd)} title="ماژول ها" />
            <Button icon="pi pi-dollar" rounded severity="help" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowPriceClick(row, cInd)} title="تنظیم قیمت" />
            <Button icon="pi pi-sliders-v" rounded severity="info" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowProposeClick(row, cInd)} title="بسته های پیشنهادی" />
            <Button icon="pi pi-trash" rounded severity="danger" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowDeleteClick(row, cInd)} title="حذف" />
        </Row>
        );
    }
    //=====================================================================================================================================
    //============                  product edit form                  =======================================================================
    //=====================================================================================================================================
    const checkDataEntry = function(){
        if(productType == null){
            setErrorMessage("نوع محصول را انتخاب کنید");
            setErorVisible(true);
            return false;
        }
        if(enName.trim().length < 2){
            setErrorMessage("نام انگلیسی محصول را وارد کنید");
            setErorVisible(true);
            return false;
        }

        return true;
    }
    const saveItem = function(){
        if(!checkDataEntry()) return;
        var url = config.Server + `/basic/product/main/save`;
        var params = {
            login:util.getLoginDto(), 
            id:productId,
            productTypeId:productType.id,
            isActive:isActive,
            enName:enName,
            shortDescription:shortDescription,
            longDescription:longDescription,
        };
        setSaving(true);
        console.log("params to save is>", params);
        console.log("url to save is>", url);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                var ncs = [...products];
                if(productIndex == -1){                    
                    ncs.push({...response});                    
                }
                else{
                    ncs[productIndex] = {...response};
                }
                setProducts(ncs);
                setSaving(false);
                setEditFormVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });

    }
    const editDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{setEditFormVisible(false)}} saving={saving} />
        )
    }
    //=====================================================================================================================================
    //============                  product module form                  =======================================================================
    //=====================================================================================================================================
    const onRowModuleClick = function(p, cInd){
        console.log("product is>", p)
        setProductId(p.id);
        setProductIndex(cInd);
        setProductType(p.productType);
        setEnName(p.enName);
        var maxModules = 30;
        var ms = [...p.modules]; 
        while(ms.length < maxModules){
            ms.push({code:"", title:"", shortDescription:"", longDescription:"", isMandatory:false, price:0, order:0, isDisabled:false});
        }
        for(var i=0;i<ms.length;i++){
            if(i == 0){
                ms[i]["isMandatory"] = true;
                ms[i]["isDisabled"] = true;
                ms[i].code = "MAIN";
                ms[i].title = "جداول و تنظیمات";
            }
            else{
                ms[i]["isDisabled"] = false;
            }
        }       
        setModules(ms);
        setModuleFormVisible(true);
    }
    const checkDataEntry_module = function(){
        var ms = [];
        for(var i=0;i<modules.length;i++){
            if(modules[i].code.trim() == "")continue;
            if(modules[i].title.trim() == ""){
                setErorVisible(true);
                setErrorMessage("نام ماژول مربوط به "+modules[i].code+" مشخص نشده است");
                return null;
            }
            ms.push({
                code:modules[i].code.trim(),
                title:modules[i].title.trim(),
                shortDescription:"",
                longDescription:"",
                isMandatory:modules[i].isMandatory,
            });
        }
        if(ms.length == 0){
            setErorVisible(true);
            setErrorMessage("هیچ ماژولی جهت ثبت تنطیم نشده است");
            return null;
        }
        return ms;
    }
    const saveModules = function(){
        var ms = checkDataEntry_module();
        if(ms == null) return;
        var url = config.Server + `/basic/product/modules/save`;
        var params = {
            login:util.getLoginDto(), 
            id:productId,
            modules:ms,
        };
        setSaving(true);
        console.log("params to save is>", params);
        console.log("url to save is>", url);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                var ncs = [...products];
                if(productIndex == -1){                    
                    ncs.push({...response});                    
                }
                else{
                    ncs[productIndex] = {...response};
                }
                setProducts(ncs);
                setSaving(false);
                setModuleFormVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });

    }
    const moduleDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveModules()}} onCancelClick={()=>{setModuleFormVisible(false)}} saving={saving} />
        )
    }
    //=====================================================================================================================================
    //============                  product price form                  =======================================================================
    //=====================================================================================================================================
    const onRowPriceClick = function(p, cInd){
        console.log("product is>", p)
        setProductId(p.id);
        setProductIndex(cInd);
        setProductType(p.productType);
        setEnName(p.enName);
        setBasePrice(p.basePrice);
        var ms = [...p.modules]; 
        for(var i=0;i<ms.length;i++){
            var t = 0;
            if(ms[i].price >= 10){
                t = parseInt(Math.floor(ms[i].price/10));
            }
            ms[i]["tooman"] = t;
        }
        setModules(ms);
        setPriceFormVisible(true);
    }
    const checkDataEntry_price = function(){
        var ms = [];
        for(var i=0;i<modules.length;i++){
            if(modules[i].code.trim() == "")continue;
            ms.push({
                code:modules[i].code.trim(),
                price:modules[i].price,
            });
        }
        return ms;
    }
    const savePrice = function(){
        var ms = checkDataEntry_price();
        if(ms == null) return;
        var url = config.Server + `/basic/product/price/save`;
        var params = {
            login:util.getLoginDto(), 
            id:productId,
            basePrice:basePrice,
            modules:ms,
        };
        setSaving(true);
        console.log("params to save is>", params);
        console.log("url to save is>", url);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                var ncs = [...products];
                if(productIndex == -1){                    
                    ncs.push({...response});                    
                }
                else{
                    ncs[productIndex] = {...response};
                }
                setProducts(ncs);
                setSaving(false);
                setPriceFormVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });

    }
    const priceDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{savePrice()}} onCancelClick={()=>{setPriceFormVisible(false)}} saving={saving} />
        )
    }
    //=====================================================================================================================================
    //============                  product propose form                  =======================================================================
    //=====================================================================================================================================
    const onRowProposeClick = function(p, cInd){
        console.log("product is>", p);
        setProductId(p.id);
        setProductIndex(cInd);
        setProductType(p.productType);
        setEnName(p.enName);
        setBasePrice(p.basePrice);
        var ps = [...p.productProposedOptions];
        for(var i=0;i<ps.length;i++){
            ps[i]["count"] = ps[i].moduleCodes.length;
        }
        setProposes(ps);
        var ms = [...p.modules]; 
        for(var i=0;i<ms.length;i++){
            var t = 0;
            if(ms[i].price >= 10){
                t = parseInt(Math.floor(ms[i].price/10));
            }
            ms[i]["tooman"] = t;
            ms[i]["isDisabled"] = ms[i].isMandatory;
            ms[i]["isChecked"] = ms[i].isMandatory;
            ms[i]["isMandatoryChecked"] = ms[i].isMandatory;
        }
        setModules(ms);
        setProposeFormVisible(true);
    }
    const checkDataEntry_propose = function(){
        if(proposeTitle.trim().length == 0){
            setErorVisible(true);
            setErrorMessage("نام بسته پیشنهادی را مشخص کنید");
            return;
        }
        var ms = [];
        for(var i=0;i<modules.length;i++){
            if(modules[i].isChecked) ms.push({code:modules[i].code, isMandatory:modules[i].isMandatoryChecked});
        }
        return ms;
    }
    const savePropose = function(){
        var ms = checkDataEntry_propose();
        if(ms == null) return;
        var url = config.Server + `/basic/product/propose/save`;
        var params = {
            login:util.getLoginDto(), 
            id:productId,
            code:proposeCode,
            title:proposeTitle,
            moduleCodes:ms,
        };
        setSaving(true);
        console.log("params to save is>", params);
        console.log("url to save is>", url);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                var ncs = [...products];
                ncs[productIndex] = {...response};
                setProducts(ncs);
                var ps = [...response.productProposedOptions];
                for(var i=0;i<ps.length;i++){
                    ps[i]["count"] = ps[i].moduleCodes.length;
                }
                setProposes(ps);
                
                setSaving(false);
                setProposeEditFormVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });

    }
    const proposeDialogFooter = function(){
        return (
            <GeneralDialogFooter hideOk={true} onOkClick={()=>{}} onCancelClick={()=>{setProposeFormVisible(false)}} saving={saving} />
        )
    }
    const proposeEditDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{savePropose()}} onCancelClick={()=>{setProposeEditFormVisible(false)}} saving={saving} />
        )
    }
    const onProposeAddNewClick = function(){
        setProposeCode(util.generateRandomUString(20));
        setProposeTitle("");
        setProposeIndex(-1);

        var ms = [...modules]; 
        var sum = basePrice;
        for(var i=0;i<ms.length;i++){
            if(ms[i].isMandatory) {sum += ms[i].price; continue;}
            ms[i].isChecked = false;
            ms[i].isMandatoryChecked = false;
        }
        setProposeSum(sum);
        setModules(ms);
        setProposeEditFormVisible(true);
    }
    const onProposeRowEditClick = function(p, cInd){
        console.log("propose is>", p);
        setProposeCode(p.code);
        setProposeTitle(p.title);
        setProposeIndex(cInd);

        var ms = [...modules]; 
        var sum = basePrice;
        for(var i=0;i<ms.length;i++){
            if(ms[i].isMandatory) {sum += ms[i].price; continue;}
            var found = false;
            var isMan = false;
            for(var j=0;j<p.moduleCodes.length;j++){
                if(p.moduleCodes[j].code == ms[i].code){
                    found = true;
                    isMan = p.moduleCodes[j].isMandatory;
                    console.log("found is>", p.moduleCodes[j].code, isMan )
                }
            }
            if(found){
                sum += ms[i].price; 
                ms[i].isChecked = true;
                ms[i].isMandatoryChecked = isMan;
            }
            else{
                ms[i].isChecked = false;
                ms[i].isMandatoryChecked = false;
            }
            // if(p.moduleCodes.includes(ms[i].code)) {sum += ms[i].price; ms[i].isChecked = true;}
            // else ms[i].isChecked = false;
        }
        setProposeSum(sum);
        setModules(ms);
        setProposeEditFormVisible(true);
    }
    const setProposeRowActions = function (row, cInd) {
        return (
        <Row className="justify-content-md-center" style={{}}>
            <Button icon="pi pi-pencil" rounded severity="success" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onProposeRowEditClick(row, cInd)} title="ویرایش" />
            <Button icon="pi pi-trash" rounded severity="danger" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowProposeDeleteClick(row, cInd)} title="حذف" />
        </Row>
        );
    }
    const onRowProposeDeleteClick = function(propose, cInd){
        setProposeCode(propose.code);
        setProposeIndex(cInd);
        setConfirmDeleteProposeVisible(true);
    }
    const deleteProposeItem = function(){
        setDeleting(true);
        var params = {login:util.getLoginDto(), id:productId, id2:proposeCode};
        var url = config.Server+`/basic/product/propose/delete`;
        axios
            .post(url, params )
            .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                var ncs = [...products];
                ncs[productIndex] = {...response};
                setProducts(ncs);
                var ps = [...response.productProposedOptions];
                for(var i=0;i<ps.length;i++){
                    ps[i]["count"] = ps[i].moduleCodes.length;
                }
                setProposes(ps);

                setDeleting(false);
                setConfirmDeleteProposeVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setDeleting(false);
            }
            })
            .catch(error => {
                setDeleting(false);
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
            });
    }
    const onDeleteProposeConfirm_Accept = function(){
      deleteProposeItem();
    }
    const onDeleteProposeConfirm_Reject = function(){
        if(deleting) return;
        setConfirmDeleteProposeVisible(false);
    }
    //=====================================================================================================================================
    //============                  delete product                  =======================================================================
    //=====================================================================================================================================
    const onRowDeleteClick = function(poduct, cInd){
        setProductId(poduct.id);
        setProductIndex(cInd);
        setConfirmDeleteVisible(true);
    }
    const deleteItem = function(){
        setDeleting(true);
        var params = {login:util.getLoginDto(), id:productId};
        var url = config.Server+`/basic/product/delete`;
        axios
            .post(url, params )
            .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                var ncs = [...products];
                ncs.splice(productIndex, 1);
                setProducts(ncs);

                setDeleting(false);
                setConfirmDeleteVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setDeleting(false);
            }
            })
            .catch(error => {
                setDeleting(false);
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
            });
    }
    const onDeleteConfirm_Accept = function(){
      deleteItem();
    }
    const onDeleteConfirm_Reject = function(){
        if(deleting) return;
        setConfirmDeleteVisible(false);
    }

    //=====================================================================================================================================

    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "enName") setEnName(val);
        else if(name === "shortDescription") setShortDescription(val);
        else if(name === "longDescription") setLongDescription(val);
        else if(name === "proposeTitle") setProposeTitle(val);
        // else if(name === "title") setTitle(val);
        // else if(name === "nationalId") setNationalId(val);
    }
    const onMoculeIsMandatoryChangeed = function (value, ind){
        var ms = [...modules];
        ms[ind]["isMandatory"] = value;
        setModules(ms);
    }
    const onModuleInputChange = function(e, name, ind){
        var val = '';
        val = (e.target && e.target.value) || '';
        var ms = [...modules];
        ms[ind][name] = val;
        setModules(ms);
    }
    const onInputChanged = function(e, ind){
        if(e.value){
            if(ind == -1){
                setBasePrice(e.value);
            }
            else{
                var ms = [...modules];
                ms[ind].price = e.value;
                if(e.value<10){
                    ms[ind].tooman = 0;
                }
                else{
                    var t = parseInt(Math.floor(e.value/10));
                    ms[ind].tooman = t;
                }
                setModules(ms);                
            }
        }
        else{
            if(ind == -1){
                setBasePrice(0);
            }
            else{
                var ms = [...modules];
                ms[ind].price = 0;
                ms[ind].tooman = 0;
                setModules(ms);                
            }
        }
    }
    const onMoculeIsCheckedInProposeChangeed = function (value, ind){
        var ms = [...modules];
        ms[ind]["isChecked"] = value;
        setModules(ms);

        var sum = basePrice;
        for(var i=0;i<ms.length;i++){
            if(ms[i].isChecked) {sum += ms[i].price;}
            else ms[i].isMandatoryChecked = false;
        }
        setProposeSum(sum);

    }
    const onMoculeIsMandatoryInProposeChangeed = function (value, ind){
        var ms = [...modules];
        ms[ind]["isMandatoryChecked"] = value;
        setModules(ms);

    }
    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        (loading)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت لیست محصولات..." />
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
        :
        <>
            
            
            <div style={{textAlign:"center", padding:"5px", backgroundColor:"#ccc", marginTop:"10px", borderTopRightRadius:"5px", borderTopLeftRadius:"5px"}}>
                لیست محصولات
            </div>

              <Row style={{}}>
                <Col xs={12} md={3}>
                    <table>
                        <tr>
                            <td style={{padding:"5px"}}><Button label="ثبت محصول جدید" icon="pi pi-plus" onClick={()=>onAddNewItemClick()} severity="secondary" iconPos="right" style={{borderRadius:"5px"}} /></td>
                        </tr>
                    </table>
                </Col>
              </Row>

              <DataTable value={products} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{}} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                dataKey="id">
                {/* <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column> */}
                <Column header="#" headerStyle={{ width: '20px' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                {config.ShowListId ? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column> : <></>}
                <Column field="productType.title" header={"نام محصول"} sortable className="list-cell-text-align"></Column>
                <Column field="enName" header={"نام لاتین"} sortable className="list-cell-text-align"></Column>
                <Column field="isActive" header={"وضعیت"} body={(row, options) => row.isActive?"فعال":"غیر فعال"} sortable className="list-cell-text-align"></Column>
                <Column body={(row, options) => setRowActions(row, options.rowIndex)} exportable={false} style={{ }}></Column>
              </DataTable>

            {
                editFormVisible?
                <Dialog visible={true} style={{ width: '70rem', height:"calc(100vh - 150px)" }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                header="ثبت مشخصات کلی محصول" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => setEditFormVisible(false)}>
                    <Row>
                        <Col md={6} style={{marginTop:"5px"}}>
                            <ProductTypeCombo onChange={(val)=>{setProductType(val);}} value={productType} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <InputText value={enName} onChange={(e)=>{onInputChange(e, "enName")}} id="enName" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}} />
                                <label htmlFor="enName">نام انگلیسی</label>
                            </FloatLabel>                                                    
                        </Col>
                        <Col md={6} style={{marginTop:"25px"}}>
                            <div key={"isActive"} className="flex align-items-center">
                                <Checkbox value={isActive} inputId={"isActive"} onChange={(e)=>setIsActive(e.checked)} checked={isActive} />
                                <label htmlFor={"isActive"} className="ml-2">&nbsp;محصول برای فروش آماده باشد</label>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <InputTextarea value={shortDescription} onChange={(e)=>{onInputChange(e, "shortDescription")}} id="enName" keyfilter="" maxLength={1000} className="p-inputtext-lg" style={{width:"100%", height:"120px", textAlign:"right", direction:"rtl"}} />
                                <label htmlFor="shortDescription">شرح کوتاه</label>
                            </FloatLabel>                                                    
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <InputTextarea value={longDescription} onChange={(e)=>{onInputChange(e, "longDescription")}} id="enName" keyfilter="" className="p-inputtext-lg" style={{width:"100%", height:"350px", textAlign:"right", direction:"rtl"}} />
                                <label htmlFor="longDescription">شرح کامل</label>
                            </FloatLabel>                                                    
                        </Col>
                    </Row>

                </Dialog>
                :
                <></>
            }
            {
                moduleFormVisible?
                <Dialog visible={true} style={{ width: '70rem', height:"calc(100vh - 150px)" }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                header="ثبت ماژول های محصول" modal className="p-fluid" footer={() => moduleDialogFooter()} onHide={() => setModuleFormVisible(false)}>
                    <Row>
                        <Col md={12} style={{marginTop:"5px"}}>
                            {productType.title}
                        </Col>
                    </Row>
                    <table style={{width:"100%", borderCollapse:"collapse"}}>
                        <thead>
                            <tr>
                                <th style={{fontWeight:"bold", borderBottom:"1px solid #e0e0e0", padding:"3px", width:"60px"}}>اجباری</th>
                                <th style={{fontWeight:"bold", borderBottom:"1px solid #e0e0e0", padding:"3px", width:"100px", textAlign:"center"}}>کد</th>
                                <th style={{fontWeight:"bold", borderBottom:"1px solid #e0e0e0", padding:"3px"}}>نام ماژول</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                modules.map((m, mInd)=>{
                                    return(
                                        <tr>
                                            <td style={{borderBottom:"1px solid #e0e0e0", padding:"3px"}}>
                                                <Checkbox disabled={m.isDisabled} value={m.isMandatory} onChange={(e)=>onMoculeIsMandatoryChangeed(e.checked, mInd)} checked={m.isMandatory} />
                                            </td>
                                            <td style={{borderBottom:"1px solid #e0e0e0", padding:"3px"}}>
                                                <InputText disabled={m.isDisabled} value={m.code} onChange={(e)=>{onModuleInputChange(e, "code", mInd)}} keyfilter="" maxLength={20} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}} />
                                            </td>
                                            <td style={{borderBottom:"1px solid #e0e0e0", padding:"3px"}}>
                                                <InputText disabled={m.isDisabled} value={m.title} onChange={(e)=>{onModuleInputChange(e, "title", mInd)}} keyfilter="" maxLength={200} className="p-inputtext-lg" style={{width:"100%", textAlign:"right", direction:"ltr"}} />
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </Dialog>
                :
                <></>
            }
            {
                priceFormVisible?
                <Dialog visible={true} style={{ width: '60rem', height:"calc(100vh - 150px)" }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                header="ثبت قیمت محصول" modal className="p-fluid" footer={() => priceDialogFooter()} onHide={() => setPriceFormVisible(false)}>
                    <Row>
                        <Col md={12} style={{marginTop:"5px"}}>
                            {productType.title}
                        </Col>
                    </Row>
                    <table style={{width:"100%", borderCollapse:"collapse"}}>
                        <thead>
                            <tr>
                                <th style={{fontWeight:"bold", borderBottom:"1px solid #e0e0e0", padding:"3px", width:"100px"}}>کد</th>
                                <th style={{fontWeight:"bold", borderBottom:"1px solid #e0e0e0", padding:"3px"}}>نام ماژول</th>
                                <th style={{fontWeight:"bold", borderBottom:"1px solid #e0e0e0", padding:"3px", width:"180px"}}>قیمت ریال</th>
                                <th style={{fontWeight:"bold", borderBottom:"1px solid #e0e0e0", padding:"3px", width:"110px"}}>تومان</th>
                            </tr>
                        </thead>
                        <tbody>
                                        <tr style={{backgroundColor:"#efefef"}}>
                                            <td style={{borderBottom:"1px solid #e0e0e0", padding:"3px"}}>
                                                -
                                            </td>
                                            <td style={{borderBottom:"1px solid #e0e0e0", padding:"3px", color:"rgba(11, 129, 11, 1)"}}>
                                                قیمت پایه نرم افزار
                                            </td>
                                            <td style={{borderBottom:"1px solid #e0e0e0", padding:"3px"}}>
                                                <InputNumber value={basePrice} onChange={(e) => {onInputChanged(e, -1)}} onValueChange={(e) => {onInputChanged(e, -1)}} minFractionDigits={0} maxFractionDigits={0} style={{direction:"ltr", textAlign:"center"}} />
                                            </td>
                                            <td style={{fontWeight:"bold", borderBottom:"1px solid #e0e0e0", padding:"3px"}}>
                                                {util.toPersianDigits(util.SeperatePrice(basePrice<10?0:parseInt(Math.floor(basePrice/10)))) }
                                            </td>
                                        </tr>
                            {
                                modules.map((m, mInd)=>{
                                    return(
                                        <tr style={{backgroundColor:(mInd%2==0)?"#FFF":"#efefef"}}>
                                            <td style={{borderBottom:"1px solid #e0e0e0", padding:"3px"}}>
                                                {m.code}
                                            </td>
                                            <td style={{borderBottom:"1px solid #e0e0e0", padding:"3px"}}>
                                                {m.title}
                                            </td>
                                            <td style={{borderBottom:"1px solid #e0e0e0", padding:"3px"}}>
                                                <InputNumber value={m.price} onChange={(e) => {onInputChanged(e, mInd)}} onValueChange={(e) => {onInputChanged(e, mInd)}} minFractionDigits={0} maxFractionDigits={0} style={{direction:"ltr", textAlign:"center"}} />
                                            </td>
                                            <td style={{fontWeight:"bold", borderBottom:"1px solid #e0e0e0", padding:"3px"}}>
                                                {util.toPersianDigits(util.SeperatePrice(m.tooman)) }
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </Dialog>
                :
                <></>
            }
            {
                proposeFormVisible?
                <Dialog visible={true} style={{ width: '60rem', height:"calc(100vh - 150px)" }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                header="بسته های پیشنهادی محصول" modal className="p-fluid" footer={() => proposeDialogFooter()} onHide={() => setProposeFormVisible(false)}>
                    <Row>
                        <Col md={12} style={{marginTop:"5px"}}>
                            {productType.title}
                        </Col>
                    </Row>

                    <Row style={{}}>
                        <Col xs={2} md={12}>
                            <table>
                                <tr>
                                    <td style={{padding:"5px"}}><Button label="ثبت بسته پیشنهادی جدید" icon="pi pi-plus" onClick={()=>onProposeAddNewClick()} severity="secondary" iconPos="right" style={{borderRadius:"5px"}} /></td>
                                </tr>
                            </table>
                        </Col>
                    </Row>


                    <DataTable value={proposes} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{}} size="small" stripedRows 
                        dataKey="code">
                        {/* <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column> */}
                        <Column header="#" headerStyle={{ width: '20px' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                        <Column field="code" header={"کد بسته"} sortable className="list-cell-text-align"></Column>
                        <Column field="title" header={"نام بسته"} sortable className="list-cell-text-align"></Column>
                        <Column field="count" header={"تعداد ماژول"} sortable className="list-cell-text-align"></Column>
                        <Column body={(row, options) => setProposeRowActions(row, options.rowIndex)} exportable={false} style={{ }}></Column>
                    </DataTable>


                </Dialog>
                :
                <></>
            }
            {
                proposeEditFormVisible?
                <Dialog visible={true} style={{ width: '70rem', height:"calc(100vh - 150px)" }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                header="تنطیم ماژول های پیشنهادی محصول" modal className="p-fluid" footer={() => proposeEditDialogFooter()} onHide={() => setProposeEditFormVisible(false)}>
                    <Row>
                        <Col md={12} style={{marginTop:"5px"}}>
                            {productType.title}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} style={{marginTop:"35px"}}>
                            <FloatLabel>
                                <InputText value={proposeTitle} onChange={(e)=>{onInputChange(e, "proposeTitle")}} id="proposeTitle" keyfilter="" maxLength={200} className="p-inputtext-lg" style={{width:"100%", textAlign:"right", direction:"rtl"}} />
                                <label htmlFor="proposeTitle">نام بسته پیشنهادی</label>
                            </FloatLabel>                                                                            
                        </Col>
                    </Row>
                    <table style={{width:"100%", borderCollapse:"collapse", marginTop:"15px"}}>
                        <thead>
                            <tr style={{backgroundColor:"#8d8c8cff", color:"#FFF"}}>
                                <th style={{fontWeight:"bold", borderBottom:"1px solid #e0e0e0", padding:"6px", width:"60px"}} colSpan={5}>
                                    ماژول های مورد نیاز بسته پیشنهادی را انتخاب کنید
                                </th>
                            </tr>
                            <tr>
                                <th style={{fontWeight:"bold", borderBottom:"1px solid #e0e0e0", padding:"3px", width:"60px"}}>انتخاب</th>
                                <th style={{fontWeight:"bold", borderBottom:"1px solid #e0e0e0", padding:"3px", width:"60px"}}>اجباری</th>
                                <th style={{fontWeight:"bold", borderBottom:"1px solid #e0e0e0", padding:"3px", width:"100px"}}>کد</th>
                                <th style={{fontWeight:"bold", borderBottom:"1px solid #e0e0e0", padding:"3px", width:"120px"}}>قیمت، تومان</th>
                                <th style={{fontWeight:"bold", borderBottom:"1px solid #e0e0e0", padding:"3px"}}>نام ماژول</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                modules.map((m, mInd)=>{
                                    return(
                                        <tr>
                                            <td style={{borderBottom:"1px solid #e0e0e0", padding:"3px"}}>
                                                <Checkbox disabled={m.isDisabled} value={m.isChecked} onChange={(e)=>onMoculeIsCheckedInProposeChangeed(e.checked, mInd)} checked={m.isChecked} />
                                            </td>
                                            <td style={{borderBottom:"1px solid #e0e0e0", padding:"3px"}}>
                                                <Checkbox disabled={m.isDisabled} value={m.isMandatoryChecked} onChange={(e)=>onMoculeIsMandatoryInProposeChangeed(e.checked, mInd)} checked={m.isMandatoryChecked} />
                                            </td>
                                            <td style={{borderBottom:"1px solid #e0e0e0", padding:"3px"}}>
                                                {m.code}
                                            </td>
                                            <td style={{borderBottom:"1px solid #e0e0e0", padding:"3px"}}>
                                                {util.SeperatePrice(m.tooman)}
                                            </td>
                                            <td style={{borderBottom:"1px solid #e0e0e0", padding:"3px"}}>
                                                {m.title}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                                        <tr style={{backgroundColor:"#555", color:"#FFF"}}>
                                            <td style={{borderBottom:"1px solid #e0e0e0", padding:"6px"}} colSpan={3}>
                                                جمع کل
                                            </td>
                                            <td style={{borderBottom:"1px solid #e0e0e0", padding:"6px"}}>
                                                {util.SeperatePrice(proposeSum)}
                                            </td>
                                            <td style={{borderBottom:"1px solid #e0e0e0", padding:"6px"}}>
                                                قیمت پایه محصول به جمع کل اضافه شده است
                                            </td>
                                        </tr>
                        </tbody>
                    </table>
                </Dialog>
                :
                <></>
            }
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
            <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
            <ShowConfirm visible={confirmDeleteProposeVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteProposeConfirm_Accept} onReject={onDeleteProposeConfirm_Reject} loading={deleting} />
        </>
    )
}